export default "__VITE_ASSET__3e1c36b9__"